import { SearchResult } from "./search-result";

export class AtsFileSource {
    Id: string;
    Name: string;
}

export class FileSourceSearchResult extends SearchResult<AtsFileSource> {}
